import type { TOC } from '@ember/component/template-only';
import { PrismBreadcrumb, PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { not, or } from 'ember-truth-helpers';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import SettingsPropertyTagsTablePropertyTags from 'lumen/components/settings/property-tags/table-property-tags';
import type MarketSettingsPropertyTagsOrganizeController from 'lumen/controllers/market/settings/property-tags/organize';

interface MarketSettingsPropertyTagsOrganizeSignature {
  Args: {
    controller: MarketSettingsPropertyTagsOrganizeController;
    model: unknown;
  };
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.property_tags.organize_properties.description"}}
    @isFullHeight={{true}}
    @title={{t "settings.property_tags.organize_properties.title"}}
  >
    <:breadcrumb>
      <PrismBreadcrumb as |B|>
        <B.item
          @label={{t "settings.property_tags.title"}}
          @route="market.settings.property-tags.index"
        />
        <B.item
          @isCurrent={{true}}
          @label={{t "settings.property_tags.organize_properties.title"}}
        />
      </PrismBreadcrumb>
    </:breadcrumb>
    <:headerAfter>
      <div class="flex gap-200">
        <PrismButton
          @buttonType="secondary"
          @isDisabled={{or
            (not @controller.hasUnsavedChanges)
            @controller.saveChangesTask.isRunning
          }}
          @label={{t "general.cancel"}}
          @onClick={{@controller.cancelChanges}}
          data-test-id="button-cancel"
        />
        <PrismButton
          @isDisabled={{or
            (not @controller.hasUnsavedChanges)
            @controller.saveChangesTask.isRunning
          }}
          @isLoading={{@controller.saveChangesTask.isRunning}}
          @label={{t "general.save"}}
          @onClick={{@controller.saveChangesTask.perform}}
          data-test-id="button-save"
        />
      </div>
    </:headerAfter>
    <:default>
      <SettingsPropertyTagsTablePropertyTags
        @definitions={{@controller.definitions}}
        @isLoading={{@controller.model.data.isRunning}}
        @propertyTags={{@controller.propertyTags}}
        @reservationFilters={{@controller.reservationFilters}}
      />
    </:default>
  </SettingsPageTemplate>
</template> satisfies TOC<MarketSettingsPropertyTagsOrganizeSignature>;
